/** Google Analytics 4 — provea-immo.fr */
export const GA4_MEASUREMENT_ID =
  process.env.REACT_APP_GA_MEASUREMENT_ID?.trim() || 'G-NK2771VK4K';

export const GA4_SITE_HOST = 'provea-immo.fr';
